<template>
  <div id="page-forms">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <template>
            <v-card flat>
              <v-card-text class="px-2">
                <v-toolbar color="white" dark flat dense cad>
                  <v-toolbar-title class="indigo--text"
                    >Usuario</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-toolbar>
                <template>
                  <v-form>
                    <v-container>
                      <v-layout>
                        <v-flex xs12 md12>
                          <data-usuario></data-usuario>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </template>
              </v-card-text>
              <template>
                <v-card-actions class="pb-3">
                  <v-spacer></v-spacer>
                </v-card-actions>
              </template>
            </v-card>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import DataUsuario from "@/modules/configuration/gestionUsuario/views/UsuarioDataGestion.vue";

export default {
  components: {
    DataUsuario,
  },
  data() {
    return {};
  },

  created() {},

  mounted() {},

  computed: {},

  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
